//getProjects
import { ProFormText } from "@ant-design/pro-form";
import request from "../../../../../../utils/request";
import qs from "qs";
export const getProjects = {
  key: "getProjects",
  config: {
    name: "批而未供土地",
    title: "批而未供",
    filter: {
      child: () => {
        // eslint-disable-next-line react/jsx-key
        return [
          <ProFormText placeholder="请输入地块名称" name="keys" key="keys" />,
        ];
      },
      // beforeFilter(data) {
      //     data.years = moment(data.years).format('YYYY');
      //     return data;
      //   },
    },
    table: {
      pageSize: 10,
      async list(body: object) {
        const url = `/screen/Index/getProjects`;
        // 需要针对Parms 进行处理
        const res = await request.get(url + "?" + qs.stringify(body));
        return res.data.data;
      },
      columns: (opts = {} as any) => {
        const { goDetail, type, tableParams } = opts;
        const base = {
          title: "序号",
          dataIndex: "",
          align: "center",
          render(_value: any, _record: any, index: number) {
            const { current = 1, pageSize = 10 } = tableParams.pagination;
            return index + 1 + (current - 1) * pageSize;
          },
        };
        switch (type + "") {
          case "0": {
            // 项目总数
            return [
              base,
              {
                title: "项目名称",
                align: "center",
                dataIndex: "name",
                render(_value: any, _record: any, index: number) {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        goDetail?.(_record);
                      }}
                    >
                      {_value}
                    </div>
                  );
                },
              },
            ];
          }
          default: {
            // 项目总数
            return [
              base,
              {
                title: "项目名称",
                align: "center",
                dataIndex: "name",
                render(_value: any, _record: any, index: number) {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        goDetail?.(_record);
                      }}
                    >
                      {_value}
                    </div>
                  );
                },
              },
            ];
          }
          //   case "1": {
          //     // 项目总投资金额
          //     return [
          //       base,
          //       {
          //         title: "企业名称",
          //         align: "center",
          //         dataIndex: "company",
          //         render(_value: any, _record: any, index: number) {
          //           return (
          //             <div
          //               style={{ cursor: "pointer" }}
          //               onClick={() => {
          //                 setCurrentRecord?.(_record);
          //               }}
          //             >
          //               {_value}
          //             </div>
          //           );
          //         },
          //       },
          //     ];
          //   }
          //   case "2": {
          //     // 续建项目数量
          //     return [
          //       base,
          //       {
          //         title: "企业名称",
          //         align: "center",
          //         dataIndex: "company",
          //         render(_value: any, _record: any, index: number) {
          //           return (
          //             <div
          //               style={{ cursor: "pointer" }}
          //               onClick={() => {
          //                 setCurrentRecord?.(_record);
          //               }}
          //             >
          //               {_value}
          //             </div>
          //           );
          //         },
          //       },
          //     ];
          //   }
          //   case "3": {
          //     // 开工项目数量
          //     return [
          //       base,
          //       {
          //         title: "企业名称",
          //         align: "center",
          //         dataIndex: "company",
          //         render(_value: any, _record: any, index: number) {
          //           return (
          //             <div
          //               style={{ cursor: "pointer" }}
          //               onClick={() => {
          //                 setCurrentRecord?.(_record);
          //               }}
          //             >
          //               {_value}
          //             </div>
          //           );
          //         },
          //       },
          //     ];
          //   }
          //   case "4": {
          //     // 竣工项目数量
          //     return [
          //       base,
          //       {
          //         title: "企业名称",
          //         align: "center",
          //         dataIndex: "title",
          //         render(_value: any, _record: any, index: number) {
          //           return (
          //             <div
          //               style={{ cursor: "pointer" }}
          //               onClick={() => {
          //                 setCurrentRecord?.(_record);
          //               }}
          //             >
          //               {_value}
          //             </div>
          //           );
          //         },
          //       },
          //     ];
          //   }
          //   case "5": {
          //     // 省重点项目数量
          //     return [
          //       base,
          //       {
          //         title: "企业名称",
          //         align: "center",
          //         dataIndex: "title",
          //         render(_value: any, _record: any, index: number) {
          //           return (
          //             <div
          //               style={{ cursor: "pointer" }}
          //               onClick={() => {
          //                 setCurrentRecord?.(_record);
          //               }}
          //             >
          //               {_value}
          //             </div>
          //           );
          //         },
          //       },
          //     ];
          //   }
          //   case "6": {
          //     //  市重点项目数量
          //     return [
          //       base,
          //       {
          //         title: "企业名称",
          //         align: "center",
          //         dataIndex: "title",
          //         render(_value: any, _record: any, index: number) {
          //           return (
          //             <div
          //               style={{ cursor: "pointer" }}
          //               onClick={() => {
          //                 setCurrentRecord?.(_record);
          //               }}
          //             >
          //               {_value}
          //             </div>
          //           );
          //         },
          //       },
          //     ];
          //   }

          //   case "7": {
          //     // 市重点调度项目数量
          //     return [
          //       base,
          //       {
          //         title: "企业名称",
          //         align: "center",
          //         dataIndex: "title",
          //         render(_value: any, _record: any, index: number) {
          //           return (
          //             <div
          //               style={{ cursor: "pointer" }}
          //               onClick={() => {
          //                 setCurrentRecord?.(_record);
          //               }}
          //             >
          //               {_value}
          //             </div>
          //           );
          //         },
          //       },
          //     ];
          //   }
        }
      },
    },
  },
} as any;
